import { useEffect, useState } from "react"

import { APPLICATION_ERROR } from "../../apollo/queries"
import { ERROR_DATA } from "../../apollo/data"
import { setAppError } from "../state"
import { useQuery } from "@apollo/client"

const useError = () => {
  let error = ERROR_DATA
  const appErrorData = useQuery(APPLICATION_ERROR)
  error = appErrorData && appErrorData.data ? appErrorData.data.error : error
  const [_error, _setError] = useState(error)

  const setError = data => {
    setAppError(data)
  }

  useEffect(() => {
    if (error.message && error.code)
      console.log(`LOG: [Hook/useError] -> initialized`, error)
    //if (error.internal) console.error(error.internal)
    _setError(error)
  }, [error])

  return [_error, setError]
}

export default useError
